import StatisticsPage from "./statistics";

export default StatisticsPage;